import { render } from "./NavSwitch.vue?vue&type=template&id=b819ba74&scoped=true"
import script from "./NavSwitch.vue?vue&type=script&lang=ts"
export * from "./NavSwitch.vue?vue&type=script&lang=ts"

import "./NavSwitch.vue?vue&type=style&index=0&id=b819ba74&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b819ba74"

export default script